const APP_URL = window.appURL || "";

export const APP_PATH = APP_URL + "/wp-content/themes/screamingfrog";
export const APP_ADMIN_AJAX_PATH = APP_URL + "/wp-admin/admin-ajax.php";
